import React from "react"
//import I18n from "i18n-js/index.js.erb"

class RatesSelect extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      segment: this.props.segment ? this.props.segment : null,
      room_type: this.props.segment.room_type ? this.props.segment.room_type : null,
      rates: this.props.segment.room_type && this.props.segment.room_type.rates ? this.props.segment.room_type.rates : null,
      numberFormat: '0' + ($('#delimiter').val() || ',') + '0' + ($('#separator').val() || '.') + '00'
    }
  }

  static getDerivedStateFromProps(nextProps, prevState){
     if(nextProps.segment !== prevState.segment){
       return { segment: nextProps.segment};
    }
    else return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.segment !== this.props.segment){
      this.setState({segment: this.props.segment});
    }
  }

  render() {
    var self = this;

    if (this.state.segment.room_type && this.state.segment.room_type.rates) {
      var options = this.state.segment.room_type.rates.map((rate) => {
        return (
          <option key={rate.id} value={rate.id}>{rate.code} &ndash;
            {rate.average_amount ? ' $' + numeral(rate.average_amount / 100).format(this.state.numberFormat) : null} {I18n.t('avg_per_night')}
          </option>
        );
      });
      return (
        <div>
          <select className="form-control" onChange={this.props.onChange} name="rate_id" value={this.state.segment.rate_id || ''}>
            { !this.state.segment.rate ? <option>{I18n.t("select_ellipsis")}</option> : null }
            {options}
          </select>
        </div>
      );
    } else {
      return(
        null
      )
    }
  }

}

export default RatesSelect